import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { 
  FaFilter, 
  FaThLarge, 
  FaList, 
  FaChevronRight,
  FaChevronLeft,
  FaShoppingCart,
  FaEye,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaSearch
} from "react-icons/fa";
import { HiOutlineAdjustments } from "react-icons/hi";

const categories = [
  { name: "Oral Anabolics", count: 9, icon: "💊", color: "from-blue-500 to-cyan-500" },
  { name: "Supplements", count: 7, icon: "🫙", color: "from-purple-500 to-pink-500" },
  { name: "Injectable", count: 18, icon: "💉", color: "from-red-500 to-amber-500" },

];

const products = [
  {
    name: "D Enzymes",
    img: "/assets/supplements/d-enzymes.png",
    link: "/product/a-tren-drag-150",
    category: "Supplements",
    price: "$79.99",
    rating: 4.8,
    reviews: 124,
    isNew: true,
    isBestseller: true,
  },
  {
    name: "ECA BURN",
    img: "/assets/supplements/eca-burn.jpeg",
    link: "/product/ark-shred-400",
    category: "Supplements",
    price: "$89.99",
    rating: 4.7,
    reviews: 89,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "FISH OIL ",
    img: "/assets/supplements/fish-oil.jpeg",
    link: "/product/bold-drag-400",
    category: "Supplements",
    price: "$94.99",
    rating: 4.9,
    reviews: 203,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "JOINT SUPPORT",
    img: "/assets/supplements/joint-support.jpeg",
    link: "/product/test-drag-250",
    category: "Supplements",
    price: "$69.99",
    rating: 4.6,
    reviews: 156,
    isNew: false,
    isBestseller: false,
  },
  {
    name: "LIVER SUPPORT",
    img: "/assets/supplements/liver-support.jpeg",
    link: "/product/deca-drag-300",
    category: "Supplements",
    price: "$84.99",
    rating: 4.9,
    reviews: 178,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "ORGAN SUPPORT",
    img: "/assets/supplements/eca-burn.jpeg",
    link: "/product/tren-mix-450",
    category: "Supplements",
    price: "$99.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "PCT EXTEME",
    img: "/assets/supplements/pct-extreme.jpeg",
    link: "/product/tren-mix-450",
    category: "Supplements",
    price: "$85.99",
    rating: 4.9,
    reviews: 145,
    isNew: false,
    isBestseller: false,
  },
  {
    name: "VITAMINS",
    img: "/assets/supplements/vitamins.jpeg",
    link: "/product/tren-mix-450",
    category: "Supplements",
    price: "$96.99",
    rating: 4.9,
    reviews: 145,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "WATER OUT",
    img: "/assets/supplements/water-out.jpeg",
    link: "/product/tren-mix-450",
    category: "Supplements",
    price: "$99.99",
    rating: 4.9,
    reviews: 145,
    isNew: false,
    isBestseller: false,
  },
  {
    name: "ZMA",
    img: "/assets/supplements/zma.jpeg",
    link: "/product/tren-mix-450",
    category: "Supplements",
    price: "$79.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: true,
  },
  {
    name: "ANADREX",
    img: "/assets/orals/anadrex.jpeg",
    link: "",
    category: "Oral Anabolics ",
    price: "$79.99",
    rating: 4.8,
    reviews: 124,
    isNew: true,
    isBestseller: true,
  },
  {
    name: "AX-10",
    img: "/assets/orals/ax10.jpeg",
    link: "",
    category: "Oral Anabolics",
    price: "$89.99",
    rating: 4.7,
    reviews: 89,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "Dianex",
    img: "/assets/orals/dianex.jpeg",
    link: "",
    category: "Orals Anabolics",
    price: "$94.99",
    rating: 4.9,
    reviews: 203,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "Halotrex",
    img: "/assets/orals/halotrex.jpeg",
    link: "",
    category: "Orals Anabolics",
    price: "$69.99",
    rating: 4.6,
    reviews: 156,
    isNew: false,
    isBestseller: false,
  },
  {
    name: "Stanex",
    img: "/assets/orals/stanex.jpeg",
    link: "",
    category: "Orals Anabolics",
    price: "$84.99",
    rating: 4.9,
    reviews: 178,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "DRAG-A",
    img: "/assets/injectables/a.jpeg",
    link: "",
    category: "Injectable",
    price: "$79.99",
    rating: 4.8,
    reviews: 124,
    isNew: true,
    isBestseller: true,
  },
  {
    name: "DRAG-ATP",
    img: "/assets/injectables/atp.jpeg",
    link: "",
    category: "Injectable",
    price: "$89.99",
    rating: 4.7,
    reviews: 89,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "DRAG BOLD",
    img: "/assets/injectables/bold.jpeg",
    link: "",
    category: "Injectable",
    price: "$94.99",
    rating: 4.9,
    reviews: 203,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG DECA",
    img: "/assets/injectables/deca.jpeg",
    link: "",
    category: "Injectable",
    price: "$69.99",
    rating: 4.6,
    reviews: 156,
    isNew: false,
    isBestseller: false,
  },
  {
    name: "DRAG MAST",
    img: "/assets/injectables/mast.jpeg",
    link: "",
    category: "Injectable",
    price: "$84.99",
    rating: 4.9,
    reviews: 178,
    isNew: false,
    isBestseller: true,
  },
  {
    name: "DRAG-NPP",
    img: "/assets/injectables/npp.jpeg",
    link: "",
    category: "Injectable",
    price: "$89.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-PRIMO",
    img: "/assets/injectables/primo.jpeg",
    link: "",
    category: "Injectable",
    price: "$99.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-SUSTA",
    img: "/assets/injectables/susta.jpeg",
    link: "",
    category: "Injectable",
    price: "$87.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-TC",
    img: "/assets/injectables/tc.jpeg",
    link: "",
    category: "Injectable",
    price: "$77.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-TE",
    img: "/assets/injectables/te.jpeg",
    link: "",
    category: "Injectable",
    price: "$84.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-TREN",
    img: "/assets/injectables/tren.jpeg",
    link: "",
    category: "Injectable",
    price: "$65.99",
    rating: 4.9,
    reviews: 145,
    isNew: true,
    isBestseller: false,
  },
  {
    name: "DRAG-WINI",
    img: "/assets/injectables/wini.jpeg",
    link: "",
    category: "Injectable",
    price: "$97.99",
    rating: 4.9,
    reviews: 145,
    isNew: false,
    isBestseller: false,
  },
];

export default function ShopNow() {
  const [isVisible, setIsVisible] = useState(false);
  const [viewMode, setViewMode] = useState("grid"); // grid or list
  const [sortBy, setSortBy] = useState("popular");
  const [showFilters, setShowFilters] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [selectedCategories, setSelectedCategories] = useState(["Injectable"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const RatingStars = ({ rating }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => {
          if (i < fullStars) {
            return <FaStar key={i} className="text-amber-400 text-sm" />;
          } else if (i === fullStars && hasHalfStar) {
            return <FaStarHalfAlt key={i} className="text-amber-400 text-sm" />;
          } else {
            return <FaRegStar key={i} className="text-gray-300 text-sm" />;
          }
        })}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">    
        {/* Toolbar */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-4">
            {/* Filter Toggle */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="lg:hidden flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 hover:border-red-600 hover:text-red-600 transition-colors"
            >
              <HiOutlineAdjustments />
              Filters
            </button>

            {/* View Toggle */}
            <div className="flex items-center gap-2 border border-gray-200 rounded-lg p-1 bg-white">
              <button
                onClick={() => setViewMode("grid")}
                className={`p-2 rounded ${viewMode === "grid" ? "bg-red-600 text-white" : "text-gray-400 hover:text-red-600"}`}
              >
                <FaThLarge />
              </button>
              <button
                onClick={() => setViewMode("list")}
                className={`p-2 rounded ${viewMode === "list" ? "bg-red-600 text-white" : "text-gray-400 hover:text-red-600"}`}
              >
                <FaList />
              </button>
            </div>

            {/* Results Count */}
            <p className="text-sm text-gray-500 hidden sm:block">
              Showing <span className="font-semibold text-gray-900">1-6</span> of{" "}
              <span className="font-semibold text-gray-900">18</span> products
            </p>
          </div>

          {/* Search and Sort */}
          <div className="flex items-center gap-4">
            {/* Search */}
            <div className="relative">
              <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-red-600 text-sm w-48 lg:w-64"
              />
            </div>

            {/* Sort */}
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-red-600"
            >
              <option value="popular">Most Popular</option>
              <option value="newest">Newest</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="rating">Highest Rated</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          
          {/* Categories Sidebar */}
          <aside className={`lg:col-span-1 ${showFilters ? 'block' : 'hidden lg:block'}`}>
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 sticky top-24">
              <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <FaFilter className="text-red-600" />
                Categories
              </h2>

              <div className="space-y-3">
                {categories.map((cat) => (
                  <label
                    key={cat.name}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gradient-to-r hover:from-red-50 hover:to-amber-50 transition-all group"
                  >
                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        checked={selectedCategories.includes(cat.name)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCategories([...selectedCategories, cat.name]);
                          } else {
                            setSelectedCategories(selectedCategories.filter(c => c !== cat.name));
                          }
                        }}
                        className="w-4 h-4 text-red-600 rounded border-gray-300 focus:ring-red-500"
                      />
                      <span className="flex items-center gap-2">
                        <span className="text-lg">{cat.icon}</span>
                        <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                          {cat.name}
                        </span>
                      </span>
                    </div>
                    <span className="text-xs bg-white px-2 py-1 rounded-full text-gray-600">
                      {cat.count}
                    </span>
                  </label>
                ))}
              </div>

              {/* Price Range */}
              <div className="mt-8">
                <h3 className="font-semibold text-gray-900 mb-4">Price Range</h3>
                <div className="space-y-4">
                  <input
                    type="range"
                    min="0"
                    max="200"
                    value={priceRange[1]}
                    onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-red-600"
                  />
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">${priceRange[0]}</span>
                    <span className="text-gray-600">to</span>
                    <span className="text-gray-600">${priceRange[1]}</span>
                  </div>
                </div>
              </div>

              {/* Clear Filters */}
              <button
                onClick={() => {
                  setSelectedCategories([]);
                  setPriceRange([0, 200]);
                  setSearchTerm("");
                }}
                className="mt-6 w-full px-4 py-2 border border-gray-200 text-gray-600 rounded-lg hover:border-red-600 hover:text-red-600 transition-colors text-sm"
              >
                Clear All Filters
              </button>
            </div>
          </aside>

          {/* Products Grid */}
          <section className="lg:col-span-3">
            <div className={viewMode === "grid" 
              ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
              : "space-y-4"
            }>
              {products.map((product, index) => (
                <div
                  key={product.name}
                  className={`group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-1 ${
                    viewMode === "list" ? "flex" : ""
                  }`}
                >
                  {/* Image Container */}
                  <div className={`relative ${viewMode === "list" ? "w-48 flex-shrink-0" : ""}`}>
                    <img
                      src={product.img}
                      alt={product.name}
                      className={`w-full object-cover ${viewMode === "list" ? "h-full" : "h-64"}`}
                    />
                    
                    {/* Badges */}
                    <div className="absolute top-3 left-3 flex gap-2">
                      {product.isNew && (
                        <span className="px-2 py-1 bg-gradient-to-r from-red-600 to-amber-600 text-white text-xs font-bold rounded-full">
                          NEW
                        </span>
                      )}
                      {product.isBestseller && (
                        <span className="px-2 py-1 bg-gradient-to-r from-amber-500 to-yellow-500 text-white text-xs font-bold rounded-full">
                          BESTSELLER
                        </span>
                      )}
                    </div>

                    {/* Quick Actions */}
                    <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button className="w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors">
                        <FaEye />
                      </button>
                    </div>
                  </div>

                  {/* Product Info */}
                  <div className={`p-5 ${viewMode === "list" ? "flex-1" : ""}`}>
                    <span className="text-xs text-gray-500">{product.category}</span>
                    <h3 className="mt-1 font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                      {product.name}
                    </h3>

                    {/* Rating */}
                    <div className="flex items-center gap-2 mt-2">
                      <RatingStars rating={product.rating} />
                      <span className="text-xs text-gray-500">({product.reviews})</span>
                    </div>

                    {/* Price */}
                    <div className="mt-3">
                      <span className="text-2xl font-bold text-gray-900">{product.price}</span>
                    </div>

                    {/* Description (for list view) */}
                    {viewMode === "list" && (
                      <p className="text-sm text-gray-600 mt-3 line-clamp-2">
                        Premium quality injectable steroid for advanced users. 
                        Manufactured under strict quality control standards.
                      </p>
                    )}

                    {/* Actions */}
                    <div className="flex items-center gap-2 mt-4">
                      <Link
                        to={product.link}
                        className="flex-1 px-4 py-2 bg-gradient-to-r from-gray-900 to-gray-800 text-white text-sm font-semibold rounded-lg hover:from-red-600 hover:to-amber-600 transition-all duration-300 text-center"
                      >
                        View Details
                      </Link>
                      <button className="w-10 h-10 border border-gray-200 rounded-lg flex items-center justify-center text-gray-600 hover:border-red-600 hover:text-red-600 transition-colors">
                        <FaShoppingCart />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center items-center gap-3 mt-12">
              <button className="w-10 h-10 border border-gray-200 rounded-lg flex items-center justify-center text-gray-600 hover:border-red-600 hover:text-red-600 transition-colors">
                <FaChevronLeft />
              </button>
              
              {[1, 2, 3, 4, 5].map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`w-10 h-10 rounded-lg font-medium transition-all ${
                    currentPage === page
                      ? "bg-gradient-to-r from-red-600 to-amber-600 text-white"
                      : "border border-gray-200 text-gray-600 hover:border-red-600 hover:text-red-600"
                  }`}
                >
                  {page}
                </button>
              ))}

              <button className="w-10 h-10 border border-gray-200 rounded-lg flex items-center justify-center text-gray-600 hover:border-red-600 hover:text-red-600 transition-colors">
                <FaChevronRight />
              </button>
            </div>
          </section>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-red-600/20 to-amber-600/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-600/20 to-purple-600/20 rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Stay Updated with New Products
            </h2>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              Subscribe to our newsletter and be the first to know about new injectable products and special offers
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-red-600"
              />
              <button className="px-8 py-3 bg-gradient-to-r from-red-600 to-amber-600 text-white font-semibold rounded-lg hover:shadow-xl transition-all duration-300">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}